import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Necesito vivir en Florida para crear una empresa allí?',
    a: 'No necesariamente. Muchas personas crean su empresa en Florida sin vivir en ese estado.'
  }, {
    q: '¿Qué es el EIN?',
    a: 'Es el número de identificación fiscal de tu empresa ante el IRS y suele ser importante para distintos procesos administrativos.'
  }, {
    q: '¿Qué es el Registered Agent?',
    a: 'Es la persona o entidad autorizada para recibir documentos legales en nombre de tu empresa dentro del estado.'
  }, {
    q: '¿Pueden ayudarme si todavía no estoy seguro de qué necesito?',
    a: 'Sí. Para eso también ofrecemos una sesión estratégica donde revisamos tu caso y te orientamos sobre la mejor forma de avanzar.'
  }, {
    q: '¿También ayudan con la parte digital?',
    a: 'Sí. Si quieres una presencia más profesional, también podemos ayudarte con landing page, dominio y correo corporativo.'
  }, {
    q: '¿Puedo empezar con la empresa y después agregar la presencia digital?',
    a: 'Sí. Muchos emprendedores empiezan con la creación de la empresa y, cuando están listos, suman su landing page, dominio y correo corporativo. También puedes optar por el plan completo desde el inicio si prefieres tenerlo todo listo.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="faq-section" style={{
    background: 'linear-gradient(135deg, #4a3666 0%, #5a4579 100%)',
    padding: '60px 20px'
  }} data-id="element-111">
      <style data-id="element-112">{`
        @media (min-width: 769px) {
          .faq-section { padding: 80px 40px !important; }
        }
        .faq-item { transition: all 0.3s ease; }
        .faq-item:hover {
          background: rgba(255,255,255,0.1) !important;
          border-color: rgba(255,255,255,0.2) !important;
        }
      `}</style>
      <div className="max-w-3xl mx-auto" data-id="element-113">
        <div className="text-center" style={{
        marginBottom: '32px'
      }} data-id="element-114">
          <p style={{
          color: 'rgba(255,255,255,0.5)',
          fontSize: '11px',
          fontWeight: 700,
          letterSpacing: '2px',
          textTransform: 'uppercase',
          textAlign: 'center',
          marginBottom: '8px'
        }} data-id="element-115">
            FAQ
          </p>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-[28px] md:text-[36px]" style={{
          color: '#FFFFFF',
          fontWeight: 800,
          textAlign: 'center',
          lineHeight: 1.2
        }} data-id="element-116">
            Preguntas frecuentes
          </motion.h2>
        </div>

        <div data-id="element-117">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="faq-item overflow-hidden" style={{
          background: 'rgba(255,255,255,0.07)',
          border: '1px solid rgba(255,255,255,0.1)',
          borderRadius: '12px',
          marginBottom: '8px'
        }} data-id="element-118">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between text-left focus:outline-none" style={{
            padding: '18px 20px',
            color: '#FFFFFF',
            fontSize: '15px',
            fontWeight: 600,
            background: 'transparent'
          }} data-id="element-119">
                <span className="pr-8" data-id="element-120">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 transition-transform duration-300 flex-shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} style={{
              color: 'rgba(255,255,255,0.7)'
            }} data-id="element-121" />
              </button>
              <AnimatePresence data-id="element-122">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-123">
                    <div style={{
                padding: '0 20px 18px',
                color: 'rgba(255,255,255,0.75)',
                fontSize: '14px',
                lineHeight: 1.6
              }} data-id="element-124">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}